import React from 'react'
import { IconSVGType } from '../../../types/icons'

/**
 * @param {IconSVGType} props
 */
const FilePNGIcon = (props: IconSVGType) => {
  return (
    <svg
      className={props.className}
      fill='none'
      height={props.height}
      viewBox={props.viewBox || '0 0 24 24'}
      width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='#5D5D5D'
        fillRule='evenodd'
        d='M4.01 4c0-1.1.89-2 1.99-2h7.17c.53 0 1.04.21 1.41.59l4.83 4.83c.38.37.59.88.59 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16ZM13 3.5V8c0 .55.45 1 1 1h4.5L13 3.5ZM6.822 17H5.317v-4.9h1.869c1.21 0 2.037.56 2.037 1.729v.042c0 1.211-.91 1.771-2.023 1.771h-.378V17Zm0-3.668v1.169h.3c.358 0 .61-.189.61-.567v-.028c0-.385-.231-.574-.602-.574h-.308ZM11.124 17H9.64v-4.9h1.435l1.393 2.072V12.1h1.477V17h-1.358l-1.463-2.177V17Zm7.614-.518a3.052 3.052 0 0 1-1.855.616c-1.358 0-2.43-.938-2.43-2.478v-.133c0-1.484 1.05-2.485 2.43-2.485.707 0 1.26.217 1.764.623l-.798 1.113c-.252-.224-.54-.385-.903-.385-.553 0-.966.448-.966 1.176v.084c0 .784.413 1.204.952 1.204.203 0 .315-.035.406-.084v-.588h-.672v-1.064h2.072v2.401Z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default FilePNGIcon
